<section class="py-4">

  <div class="card mx-2 my-4 m-md-4">
    <div class="table-responsive">

      <div class="row">
        <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="listaUnidades" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
          [(selection)]="unidade" [first]="first" [globalFilterFields]="['unidadepai', 'nomefantasia', 'nome', 'documento', 'estado', 'motivobloqueio']">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.idunidade" (tableOrderChange)="getListaUnidades()">
                #</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.unidadepai" (tableOrderChange)="getListaUnidades()">
                Unidade pai</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.nomefantasia"
                (tableOrderChange)="getListaUnidades()">Nome Unidade</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.nome" (tableOrderChange)="getListaUnidades()">Tipo
                Unidade</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.documento" (tableOrderChange)="getListaUnidades()">
                Documento</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.estado" (tableOrderChange)="getListaUnidades()">
                Estado</th>
              <th [tableOrderGroup]="sorting" [(tableOrder)]="sorting.motivobloqueio" (tableOrderChange)="getListaUnidadesComBloqueio()">Motivo Bloqueio</th>
              <th class="text-center py-2" *ngIf="usuario.permissoes.administrador">
                <a [routerLink]="['/unidade','adicionar']" class="btn btn-sm btn-success btn-icon">
                  <i class="mdi mdi-plus"></i>
                  <span>Unidade</span>
                </a>
              </th>
            </tr>
            <tr>
              <th class="py-1 px-2"><input [formControl]="pesquisa.controls.idunidade" type="text"
                class="form-control text-uppercase"></th>
                <th class="py-1 px-2"><input [formControl]="pesquisa.controls.unidadepai" type="text"
                    class="form-control text-uppercase"></th>
                <th class="py-1 px-2"><input [formControl]="pesquisa.controls.nomefantasia" type="text"
                    class="form-control text-uppercase"></th>
                <th class="py-1 px-2"><input [formControl]="pesquisa.controls.nome" type="text"
                    class="form-control text-uppercase"></th>
                <th class="py-1 px-2"><input [formControl]="pesquisa.controls.documento" type="text"
                    class="form-control text-uppercase" mask="00.000.000/0000-00"></th>
                <th class="py-1 px-2">
                  <select [formControl]="pesquisa.controls.estado" class="form-control text-uppercase">
                    <option value=""></option>
                    <option *ngFor="let o of listaEstados" value="{{o.value}}">{{o.label}}</option>
                  </select>
                </th>
                <th class="py-1 px-2">
                  <select [formControl]="pesquisa.controls.motivobloqueio" type="text" class="form-control text-uppercase">
                    <option value=""></option>
                    <option *ngFor="let o of listaMotivos" value="{{o.label}}">{{o.label}}</option>
                   </select>
                </th>
                <th></th>

          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td>{{rowData.idunidade}}</td>
              <td>{{rowData.unidadepai | uppercase}}</td>
            <td>{{rowData.nomefantasia | uppercase}}</td>
            <td>{{rowData.nome | uppercase}}</td>
            <td>{{rowData.documento}}</td>
            <td>{{rowData.estado | uppercase}}</td>
            <td>{{rowData.motivobloqueio | uppercase}}</td>
            <td class="py-1" >
              <div class="d-flex align-items-center justify-content-end">
                <span  data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="visualizarUnidade(rowData)" class="btn btn-sm btn-icon btn-info mx-1">
                    <i class="mdi mdi-eye"></i>
                  </button></span>
                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Editar">
                <button (click)="editarUnidade(rowData)" class="btn btn-sm btn-icon btn-primary mx-1">
                  <i class="mdi mdi-pencil"></i>
                </button></span>
                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Excluir">
                <button (click)="removerUnidade(rowData)" class="btn btn-sm btn-danger btn-icon mx-1">
                  <i class="mdi mdi-delete"></i>
                </button></span>
                <app-input-toggle *ngIf="usuario.permissoes.administrador" bgOffColor="bg-danger" bgColor="bg-success"
                  (checkedChange)="mudarStatusUnidade($event, rowData)" [checked]="rowData.status"></app-input-toggle>
              </div>
            </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" let-columns>
            <div class="card-footer bg-white row justify-content-between" style="min-width: 600%;">
              <div class="pb-2 pb-sm-0">
                <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="total"
                  [(page)]="this.filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
                </ngb-pagination>
              </div>
              <div class="pb-2 pb-sm-0">
                <div class="btn-group" role="group">
                  <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                      class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom"></button></span>
                  <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  filter.per_page==10}"
                    type="button" class="btn btn-outline-primary">10</button>
                  <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}"
                    type="button" class="btn btn-outline-primary">25</button>
                  <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}"
                    type="button" class="btn btn-outline-primary">50</button>
                  <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}"
                    type="button" class="btn btn-outline-primary">100</button>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhuma consulta foi encontrada com os filtros informados
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </div>

  </div>
</section>
